/*----------------------
        HEADER
---------------------- */

headerLogoAnimation = {
    init: function () {
        const logo = document.querySelector('.header__logo');
        let animating = false;

        logo.addEventListener('mouseenter', () => {
            logo.style.transition = '';
            logo.style.backgroundColor = '';
            logo.classList.add('logo-animating');
            animating = true;
        });

        logo.addEventListener('mouseleave', () => {
            // Get the computed color at the moment hover ends
            const computedColor = getComputedStyle(logo).backgroundColor;
            logo.classList.remove('logo-animating');
            logo.style.backgroundColor = computedColor;
            // Force reflow to apply the style before transitioning
            void logo.offsetWidth;
            logo.style.transition = 'background-color 0.3s ease';
            logo.style.backgroundColor = 'var(--yellow)';
            animating = false;
        });
    }
};

hideMenuInFooter = {
    init: function () {
        var controller = new ScrollMagic.Controller();
        var target = $("section.section-header");

        var hideMenuInFooter = new ScrollMagic.Scene({
            triggerElement: '.footer-trigger',
            triggerHook: 0.2,
        }).on('start', function () {
            target.addClass("hidden");
        }).on("leave", function () {
            target.removeClass("hidden");
        }).addTo(controller);
    }
};

headerHover = {
    init: function () {
        $(".header__nav__item__link").on('mouseenter', function () {
            $(this).closest('.header__nav').find('.header__nav__item__link').addClass('no-hover');
            $(this).removeClass('no-hover');
        });

        $(".header__nav__item__link").on('mouseleave', function () {
            $(".header__nav__item__link").removeClass('no-hover');

            if ($("body").hasClass('shop-menu--open')) {
                $(".header__nav.nav--left .header__nav__item:not(.item--shop-menu) .header__nav__item__link").addClass('no-hover');
            }
        });
    }
};

shopMenu = {
    init: function () {
        /* SHOP MENU */
        $(".open--shop-menu").on('click', function () {
            if (!$("body").hasClass('shop-menu--open')) {
                // OPEN
                $("body").addClass('shop-menu--open');
                /* HOVER EFFECT */
                $(this).closest('.header__nav').find('.header__nav__item__link').addClass('no-hover');
                $(this).closest('.header__nav__item__link').removeClass('no-hover');

            } else {
                // CLOSE
                $("body").removeClass('shop-menu--open');
                $('.header__nav__item__link').removeClass('no-hover');
            }
        });

        $(".shop-menu__close-btn").on('click', function () {
            $("body").removeClass('shop-menu--open');
            $('.header__nav__item__link').removeClass('no-hover');
        });

        $("body").on("click", function (event) {
            if (!$(event.target).closest('section.section-shop-menu').length && !$(event.target).closest('.open--shop-menu').length) {
                $("body").removeClass('shop-menu--open');
                $('.header__nav__item__link').removeClass('no-hover');
            }
        });

        /*   ---   HOVER EFFECTS   ---    */
        $(".shop-menu-product").on('mouseenter', function () {
            $(".shop-menu-product").addClass('no-hover');
            $(this).removeClass('no-hover');
        });

        $(".shop-menu-product").on('mouseleave', function () {
            $(".shop-menu-product").removeClass('no-hover');
        });
    }
};

mobileMenu = {
    init: function () {
        /* MOBILE MENU */
        $(".open--mobile-menu").on('click', function () {
            if (!$("body").hasClass('mobile-menu--open')) {
                // OPEN
                $("body").addClass('mobile-menu--open');

            } else {
                // CLOSE
                $("body").removeClass('mobile-menu--open');
            }
        });

        $(".mobile-menu__close-btn").on('click', function () {
            $("body").removeClass('mobile-menu--open');
        });

        $("body").on("click", function (event) {
            if (!$(event.target).closest('section.section-mobile-menu').length && !$(event.target).closest('.open--mobile-menu').length) {
                $("body").removeClass('mobile-menu--open');
            }
        });

        /* SUBMENUs */
        $(".mobile-menu__nav__item.has-submenu .mobile-menu__nav__item__link").on('click', function () {
            var parent = $(this).closest('.mobile-menu__nav__item');

            if (!parent.hasClass('open')) {
                parent.find('.shop-submenu').css('height', parent.find('.shop-submenu-inner').outerHeight() + 'px');
                parent.addClass('open');
            } else {
                parent.find('.shop-submenu').css('height', '0');
                parent.removeClass('open');
            }
        });
    }
};

headerPopup = {
    init: function () {

        // Check for 'seenPopup' cookie
        function getCookie(name) {
            var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
            if (match) return match[2];
            return null;
        }

        function addCookie() {
            var d = new Date();
            // Set the cookie to expire in 30 days
            d.setTime(d.getTime() + (30 * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = "seenPopup=true;" + expires + ";path=/";
        }

        if ($(".section-header-popup").length > 0) {
            if (!getCookie('seenPopup')) {
                setTimeout(function () {
                    $(".section-header-popup").addClass('active');
                }, 20000);
                addCookie();
            }
        }

        $(".header-popup__close-btn").on('click', function () {
            $(".section-header-popup").removeClass('active');
            addCookie();
        });
    }
};

/*----------------------
        OTHERS
---------------------- */

invertedColors = {
    init: function () {
        var controller = new ScrollMagic.Controller();

        $('.invert-colors').each(function () {
            var $el = $(this);

            var scene = new ScrollMagic.Scene({
                triggerElement: this,
                triggerHook: 0.1,
                duration: $el.outerHeight()
            }).on('enter', function () {
                $('body').addClass('invert-colors');
            }).on('leave', function (event) {
                $('body').removeClass('invert-colors');
            }).addTo(controller);

        });
    }
};

fixedSection = {
    init: function () {
        var controller = new ScrollMagic.Controller();

        $('.fixed-section').each(function () {
            var $el = $(this);
            var trigger = $el.data('trigger');

            var sceneEnter = new ScrollMagic.Scene({
                triggerElement: '.' + trigger,
                triggerHook: 0,
                duration: $el.outerHeight()
            }).on('enter', function () {
                $(".fixed-section").removeClass('fixed--active');
                $el.addClass('fixed--active');
            }).addTo(controller);

            var sceneLeave = new ScrollMagic.Scene({
                triggerElement: '.' + trigger,
                triggerHook: 1,
                duration: $el.outerHeight()
            }).on('enter', function () {
                $(".fixed-section").removeClass('fixed--active');
                $el.addClass('fixed--active');
            }).addTo(controller);
        });
    }
};

langMenu = {
    init: function () {
        $(".current-lang").on('click', function () {
            $(".header-lang").addClass('open');
        });

        $("body").on("click", function (event) {
            if (!$(event.target).closest('.current-lang').length && !$(event.target).closest('.header-lang').length) {
                $(".header-lang").removeClass('open');
            }
        });
    }
};

SVG = {
    init: function () {
        jQuery('img.svg').each(function () {
            var $img = jQuery(this);
            var imgID = $img.attr('id');
            var imgClass = $img.attr('class');
            var imgURL = $img.attr('src');

            jQuery.get(imgURL, function (data) {
                // Get the SVG tag, ignore the rest
                var $svg = jQuery(data).find('svg');

                // Add replaced image's ID to the new SVG
                if (typeof imgID !== 'undefined') {
                    $svg = $svg.attr('id', imgID);
                }
                // Add replaced image's classes to the new SVG
                if (typeof imgClass !== 'undefined') {
                    $svg = $svg.attr('class', imgClass + ' replaced-svg');
                }

                // Remove any invalid XML tags as per http://validator.w3.org
                $svg = $svg.removeAttr('xmlns:a');

                // Replace image with new SVG
                $img.replaceWith($svg);

            }, 'xml');
        });
    }
};

$(function () {
    $("body").css('opacity', 1);

    // HEADER
    headerLogoAnimation.init();
    hideMenuInFooter.init();
    headerPopup.init();
    headerHover.init();
    mobileMenu.init();
    shopMenu.init();

    // OTHERS
    invertedColors.init();
    fixedSection.init();
    langMenu.init();
    SVG.init();
});
